import history from 'history/browser'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import './Footer.css'
import { Conditionnal } from '../ImportAll'
import { step } from '../../engine/StepDefinition'

class Footer extends Component {
    render() {
        // Recalcule la chaîne d'esquive SMS de EnregistrerDossier (Rules.js) pour le mode debug
        let esquiveSmsRaison = null
        if (this.props.techPartEstCgp === true) {
            esquiveSmsRaison = 'partenaire CGP'
        } else if (this.props.techPartEsquiveSms === true) {
            esquiveSmsRaison = 'esquive_sms partenaire'
        } else if (
            this.props.contactMobile &&
            this.props.contactMobile.startsWith('+1')
        ) {
            esquiveSmsRaison = 'indicatif +1'
        } else if (this.props.sourceEsquiveSms === true) {
            esquiveSmsRaison = 'param url esquive_sms'
        } else if (this.props.sourceDemandeHorsFrance === true) {
            esquiveSmsRaison = 'hors France'
        }

        var afficherGoHome = <div className="gohome regular-font"></div>
        if (this.props.view && this.props.view !== 0) {
            afficherGoHome = (
                <div className="gohome regular-font">
                    <a
                        href="#"
                        onClick={() =>
                            history.push('/tunnelmobile/', { targetView: 0 })
                        }
                    >
                        Retour à l’accueil
                    </a>
                </div>
            )
        }
        return (
            <div className="Footer regular-font">
                <Conditionnal
                    linked_data_id="tech_device_size"
                    isEqualTo
                    targetDataValueCompare="DESKTOP"
                >
                    <img
                        src="svg/Fill_1.svg"
                        className="svg_footer fill1"
                        alt="maison"
                    />
                    <img
                        src="svg/Fill_2.svg"
                        className="svg_footer fill2"
                        alt="maison"
                    />
                    <img
                        src="svg/Fill_2.svg"
                        className="svg_footer fill3"
                        alt="maison"
                    />
                    <img
                        src="svg/balance_full.svg"
                        className="svg_footer balance"
                        alt="maison"
                    />
                    <img
                        src="svg/nego.svg"
                        className="svg_footer nego"
                        alt="maison"
                    />
                </Conditionnal>
                <div className="textinfo regular-font">
                    Un crédit vous engage et doit être remboursé.
                    <br />
                    Vérifiez vos capacités de remboursement avant de vous
                    engager.
                    <Conditionnal linked_data_id="tech_debug_mode" isNotEmpty>
                        <span className="localisation_indicator">
                            Debug : Vue {step[this.props.view].id_text} (
                            {step[this.props.view].description})
                        </span>
                        <br />
                        <span className="localisation_indicator">
                            {esquiveSmsRaison
                                ? 'Debug : esquive SMS = OUI (' +
                                  esquiveSmsRaison +
                                  ')'
                                : 'Debug : esquive SMS = NON (dépend du backend controletel/estNecessaire)'}
                        </span>
                    </Conditionnal>
                </div>

                <div className="textinfo regular-font">
                    Monemprunt.com - Bâtiment Equinoxe
                    <br />
                    1 rue Robert Duvivier 35000 Rennes
                    <br />
                    Orias N° 16004773 et N° Siren : 821207081 <br />
                    <a
                        target="_blank"
                        href="https://www.immodvisor.com/pro/monempruntcom-rennes-35760-22278.html"
                    >
                        Lire nos avis
                    </a>
                </div>

                {afficherGoHome}
                <a
                    href="#"
                    className="ot-sdk-show-settings textinfo regular-font"
                >
                    Cookie Settings
                </a>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        view: state.view,
        techPartEstCgp: state.answer.tech_part_est_cgp,
        techPartEsquiveSms: state.answer.tech_part_esquive_sms,
        contactMobile: state.answer.contact_mobile,
        sourceEsquiveSms: state.answer.source_esquive_sms,
        sourceDemandeHorsFrance: state.answer.source_demande_hors_france,
    }
}

export default connect(mapStateToProps)(Footer)
